import React, { useState, VFC } from 'react'
import styles from '../../styles/front/form/Form.module.sass'
import FormTemplate from '../form/Common'
import ScrollError from '../form/ScrollError'

type LineFrom = {
  name: string
  tel: string
}

type Builder = {
  theme_color: string
}

type LineFormProps = {
  lineForm: LineFrom
  builder: Builder
  terms_path: string
  privacy_path: string
  errors?: { [key: string]: string[] }
}

// event_detail_LineForm_error_handler.jsでerrorTextのクラスを取得するために定義
export const getErrorClassName = () => styles.errorText

const LineForm: VFC<LineFormProps> = (props: LineFormProps) => {
  const { errors, builder, lineForm, terms_path, privacy_path } = props

  const [isValidForm, setIsValidForm] = useState(errors && checkIsValidForm())
  const [isValidLineFormParams, setIsValidLineFormParams] = useState(false)

  function checkIsValidForm() {
    const errorKeys = Object.keys(errors!)
    const formKeys = ['name', 'tel']
    return !formKeys.some((el) => errorKeys.includes(el))
  }

  const handleValueChange = (isValid) => {
    console.log('isValid', isValid)
    setIsValidForm(isValid)
    isValidParams(isValid)
  }

  function isValidParams(isTemplateFormValid) {
    if (!isTemplateFormValid) {
      setIsValidLineFormParams(false)
      return
    }

    setIsValidLineFormParams(true)
  }

  const [blankCheck, setBlankCheck] = useState(0)

  const scroll = window.innerWidth >= 989 ? 20 : 45

  const checkBlank = (e) => {
    if (!isValidLineFormParams) {
      e.preventDefault()
      setBlankCheck(blankCheck + 1)
      setTimeout(() => {
        let firstError = document.getElementsByClassName('error')[0]
        let rectTop = firstError.getBoundingClientRect().top
        let positionY = window.pageYOffset
        let target = rectTop + positionY - scroll
        ScrollError(target)
      }, 10)
    }
  }

  return (
    <>
      <div className={styles.form}>
        <FormTemplate
          common_form={lineForm}
          errors={errors}
          form_type="line_link_form"
          isFormValid={handleValueChange}
          isShowNameKana={false}
          placeHolderText={''}
          check={blankCheck}
          form_keys={['name', 'tel']}
        />
        <input type={'hidden'} name="commit" value="" />
        <div className={styles.formText}>
          <a href={terms_path} className={styles.link} rel="noopener" target="_blank">
            利用規約
          </a>
          と
          <a href={privacy_path} className={styles.link} rel="noopener" target="_blank">
            プライバシーポリシー
          </a>
          に同意して
        </div>
        <div className={styles.spSubmitContainer}>
          <input
            type={'submit'}
            name={'submit'}
            value={`${isValidLineFormParams ? 'LINE連携に進む' : 'まだ入力が完了していません'}`}
            className={`${styles.submitButton} ${
              isValidLineFormParams ? `${styles.submitButtonAbled} submit-color -${builder.theme_color} -primary` : ``
            }`}
            onClick={(e) => checkBlank(e)}
          />
        </div>
      </div>
    </>
  )
}

export default LineForm
